// Map.tsx
import React from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";

const PROG = 'BusinessLocation';

const BusinessLocation = (props) => {

  const numberWithCommas = (x) => {
    x = x.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) {
      x = x.replace(pattern, "$1,$2");
    }
    return x;
  }

  return (
    <div style={{ width : '100%', paddingLeft : 10, paddingRight : 20 }}>
      <div style={{ display : 'flex', backgroundColor : '#eee', margin : 0, flexDirection : 'row', borderRadius : 5, overflow : 'hidden' }}>
        <div style={{ width : 200, height : 200, margin : 10 }}>
          <MapContainer center={[props.location.location.latitude, props.location.location.longitude]} zoom={15} scrollWheelZoom={false} style={{ width : 200, height : 200 }}>
            <TileLayer
              attribution='OSM'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[props.location.location.latitude, props.location.location.longitude]}>
            </Marker>
          </MapContainer>
        </div>
        <div style={{ flexDirection : 'column', padding : 10 }}>
          <div style={{ fontWeight : 'bold', fontSize: 22 }}>{ props.location.displayName.text }</div>
          <div style={{ fontSize: 18 }} dangerouslySetInnerHTML={{ __html : props.location.adrFormatAddress }}></div>
          <div style={{ display : 'flex', flexDirection : 'row', paddingTop : 5 }}>
            <div style={{ flexDirection : 'column', marginTop : 3 }}>
              { props.location.currentOpeningHours.weekdayDescriptions.map((ohDay, i) => {
                return (
                  <div style={{ fontSize: 11 }}>{ ohDay }</div>
                )
              })}
            </div>
            <div style={{marginLeft : 50, flexDirection : 'column'}}>
              <div style={{ fontSize: 14 }}>TEL: <a href={'tel:'+props.location.location.internationalPhoneNumber}>{ props.location.nationalPhoneNumber }</a></div>
              <div style={{ fontSize: 14 }}>Google ID: <a href={'https://www.google.com/maps/place/?q=place_id:'+props.location.placeId} target="_googleMaps">{ props.location.placeId }</a></div>
              <div style={{ fontSize: 14 }}>Rating: { props.location.rating } stars ({ numberWithCommas(props.location.userRatingCount) } ratings)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default BusinessLocation;

